var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyListIcon25X25(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.11167 15.6836L9.71819 2.22402L23.2365 5.84624L19.2308 20.7959C18.8726 22.1324 17.5 22.926 16.165 22.5682C14.8299 22.2105 14.038 20.837 14.3961 19.5004L14.7698 18.106M14.7698 18.106L14.8974 17.6295M14.7698 18.106L2.21773 14.7428L1.70828 16.6442C1.42269 17.7101 2.05424 18.8054 3.11889 19.0907L16.049 22.5553M14.7698 18.106L15.744 18.3671M10.9639 6.70983L16.7473 8.25948M17.7112 8.51776L19.639 9.03431M9.93704 10.542L15.7204 12.0917M16.6843 12.35L18.6121 12.8665",
    stroke: "white",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyListIcon25X25);
export default __webpack_public_path__ + "static/media/my_list_icon25x25.0644316c.svg";
export { ForwardRef as ReactComponent };